import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { AppRoutes } from "./App";
import { SEO_SSG_ATTR } from "./lib/head";
import "./index.css";

// Prerendered head tags are removed BEFORE hydrating.
//
// scripts/prerender.mjs writes each route's <title>/<meta>/<link> into the
// static HTML so crawlers that do not execute JS still see them. Once React
// takes over, <Seo> renders the same tags and React 19 hoists them into <head>
// natively — so without this the document would carry two of each. They are
// tagged with SEO_SSG_ATTR precisely so we can tell the prerendered copies from
// React's and drop only ours.
for (const node of document.head.querySelectorAll(`[${SEO_SSG_ATTR}]`)) {
  node.remove();
}

const container = document.getElementById("root");
if (!container) throw new Error("landing: #root container missing from index.html");

const tree = (
  <StrictMode>
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  </StrictMode>
);

// Prerendered routes ship with markup in #root and must be hydrated so the
// static HTML is reused. /blog* and any non-prerendered path arrive with an
// empty container and mount fresh.
if (container.hasChildNodes()) {
  hydrateRoot(container, tree);
} else {
  createRoot(container).render(tree);
}
